// Клиент для `/api/public/muds` — каталог растворов публичного юзера.
// Тонкая обёртка над generic `crudClient` (см. crudClient.ts) — весь
// fetch-boilerplate там, здесь только типы, базовый путь и доменные константы.
// Типы — единый источник правды: ts-rs-генерация из
// `crates/backend/web_api_types/src/mud.rs` (alias @webtypes, см.
// vite.config.ts / tsconfig.app.json). Регенерация — `cargo test -p web_api_types`.
//
// Все размеры — SI: плотность кг·м⁻³, theta-показания и gel — в lb/100ft²
// (это уже доменные единицы FANN, в SI не пересчитываются).
// HB-параметры (tau_y, k, n) — Pa / Pa·sⁿ / dimensionless.

import type { MudDto } from '@webtypes/MudDto'
import type { CreateMudBody } from '@webtypes/CreateMudBody'
import type { UpdateMudBody } from '@webtypes/UpdateMudBody'
import { crudClient } from './crudClient'

export type { MudDto, CreateMudBody, UpdateMudBody }
// 409 = раствор используется в каком-то public_state (FK ON DELETE RESTRICT);
// страница ловит его `instanceof InUseError`.
export { InUseError } from './crudClient'

const client = crudClient<MudDto, CreateMudBody, UpdateMudBody>(
  '/api/public/muds',
  'Раствор используется в state — удалить нельзя',
)

export const listMuds = client.list
export const createMud = client.create
export const updateMud = client.update
export const deleteMud = client.remove

export const ESTIMATION_METHODS = [
  { id: 'user',     label: 'Заданные HB' },
  { id: 'simple',   label: 'Simple (по θ300/θ600)' },
  { id: 'mullinex', label: 'Mullinex' },
] as const
